import { styled } from '@mui/material';

export const StyledSectionTable = styled('div')`
    margin-top: 8px;
    padding: 0 20px;

  .MuiPaper-root{
    box-shadow: none;
  }
  .MuiToolbar-root{
    display:none;
  }
  .MuiTableCell-root { padding: 16px 0px; }
  // .addButtonRoot:hover {
  //   border: none;
  //   background: none;
  // }

  .buttonContainedRoot {
    color: #fff;
    background-color: primary.main;
    box-shadow: none;
    padding: 6px 16px;
    border-radius: 4px;
    height: 36px;
  }
  .MuiTableRow-head {
    min-height: 56px;
    max-height: 56px;
    line-height: 56px;
    border-top: 1px solid rgb(240, 240, 240);
    border-bottom: 2px solid rgb(240, 240, 240);
    background-color: rgb(250, 250, 250);

    .MuiTableCell-head {
      font-size: 0.75rem;
      font-weight: 700;
      text-transform: uppercase;
      padding: 12px;
      padding-left: 10px;
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 0;
      cursor: help;
    }
    .MuiTableCell-head:not(:last-child):after {
      position: absolute;
      content: "";
      background-color: rgb(240, 240, 240);
      width: 1px;
      height: 28px;
      right: 0px;
      top: 12px;
    }
  }
  .MuiTableBody-root {
    .MuiTableCell-body {
      padding-left: 10px;
      // font-size: 0.875rem;
      font-size: 12px;
      padding: 0 0 0 10px;
    }
  }
  .inputCell:before {
    margin: 0 10px 0 0;
  }
  .tableCell {
    .Mui-focused:after {
      transform: none;
      margin: 0 10px 0 0;
    }
  }
`;